import { PLAYER_HISTORY } from "../data/playerHistory";
import { TEAM_HISTORY as PLAY_HISTORY } from "../data/projectionData";

function computeYearShares(abbrev, year, passAtt, rushAtt) {
  if (!passAtt || !rushAtt) return null;

  const rows = [];
  for (const playerRows of Object.values(PLAYER_HISTORY)) {
    for (const row of playerRows) {
      if (row.team === abbrev && row.year === year) rows.push(row);
    }
  }

  const wrRows = rows.filter(r => r.pos === "WR").sort((a, b) => b.targets - a.targets);
  const rbRows = rows.filter(r => r.pos === "RB").sort((a, b) => b.rushAtt - a.rushAtt);

  const wr4plusTgt = wrRows.slice(3).reduce((s, r) => s + (r.targets || 0), 0);
  const rb3plusRush = rbRows.slice(2).reduce((s, r) => s + (r.rushAtt || 0), 0);
  const rb3plusTgt = rbRows.slice(2).reduce((s, r) => s + (r.targets || 0), 0);

  return {
    wr4PlusTgt: (wr4plusTgt / passAtt) * 100,
    rb3PlusRush: (rb3plusRush / rushAtt) * 100,
    rb3PlusTgt: (rb3plusTgt / passAtt) * 100,
  };
}

export function computeTeamDepthShares(abbrev) {
  const teamHistory = PLAY_HISTORY[abbrev];
  if (!teamHistory || !teamHistory.length) return null;

  const recentYears = [...teamHistory].sort((a, b) => b.year - a.year).slice(0, 3);

  const yearShares = recentYears
    .map(h => computeYearShares(abbrev, h.year, h.passAtt, h.rushAtt))
    .filter(Boolean);

  if (!yearShares.length) return null;

  const avg = key => yearShares.reduce((s, y) => s + y[key], 0) / yearShares.length;

  return {
    wr4PlusTgt: Math.round(avg("wr4PlusTgt")),
    rb3PlusRush: Math.round(avg("rb3PlusRush")),
    rb3PlusTgt: Math.round(avg("rb3PlusTgt")),
  };
}

let _leagueCache = null;

export function computeLeagueDepthShares() {
  if (_leagueCache) return _leagueCache;

  const teamResults = Object.keys(PLAY_HISTORY)
    .map(abbrev => computeTeamDepthShares(abbrev))
    .filter(Boolean);

  if (!teamResults.length) {
    _leagueCache = { wr4PlusTgt: null, rb3PlusRush: null, rb3PlusTgt: null };
    return _leagueCache;
  }

  const avg = key => teamResults.reduce((s, t) => s + t[key], 0) / teamResults.length;

  _leagueCache = {
    wr4PlusTgt: Math.round(avg("wr4PlusTgt")),
    rb3PlusRush: Math.round(avg("rb3PlusRush")),
    rb3PlusTgt: Math.round(avg("rb3PlusTgt")),
  };
  return _leagueCache;
}
